import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AvailabilityService {
  private readonly http = inject(HttpClient);

  get(sku: string): Observable<Warehouse[] | null> {
    return this.http
      .get<
        AvailabilityResponse | AvailabilityError
      >(`https://hook.eu1.make.com/vrgk4zpwaf72jmwwd3ll7pplrvh7ss4x?sku=${sku}`)
      .pipe(
        map((response) => {
          if (!('warehouses' in response)) {
            return null;
          }

          return response.warehouses.map((w) => ({
            stocks: w.stocks,
            warehouse: {
              ...w.warehouse,
              id: w.warehouse.id.toString(),
            },
          }));
        }),
      );
  }
}

type AvailabilityError = {
  Reference: string;
  Message: string;
  Data: object;
};

type AvailabilityResponse = {
  id: number;
  sku: string;
  photo: string;
  channels: string[];
  prices: Price[];
  warehouses: WarehouseDTO[];
};

type Price = {
  priceType: string;
  priceTaxIncluded: number;
  price: number;
  taxAmount: number;
  taxRate: number;
  currency: string;
  reference: null | string;
  createdAt: string;
  channel: string;
  validSince: null | string;
  validTo: null | string;
  isValid: boolean;
};

export type Stock = {
  size: null | number;
  quantity: number;
  completionDays: number;
};

type WarehouseDTO = {
  warehouse: {
    id: number;
    code: string;
    name: string;
  };
  stocks: Stock[];
};

export type Warehouse = {
  warehouse: {
    id: string;
    code: string;
    name: string;
  };
  stocks: Stock[];
};
